import * as fmt from '~/utils/i18n/format';

export const useFormat = () => {
  const { currentLocale } = useLocaleSwitch();
  const preferences = usePreferencesStore();

  return {
    formatNumber: (value: number, options?: Intl.NumberFormatOptions) =>
      fmt.formatNumber(value, currentLocale.value, options),
    formatCurrency: (value: number, currency?: string, options?: Intl.NumberFormatOptions) =>
      fmt.formatCurrency(value, currency ?? preferences.currency, currentLocale.value, options),
    formatDate: (value: Date | string | number, options?: Intl.DateTimeFormatOptions) =>
      fmt.formatDate(value, currentLocale.value, options),
    formatRelativeTime: (value: Date | string | number) => fmt.formatRelativeTime(value, currentLocale.value),
  };
};
